<template>
    <div class="ct-box">
        <div class="createweb">
            <p style="margin:100px auto 0;">恭喜！您距离成功只差一步了！！</p>
            <div class="webbox">
                <div v-if="!siteStatus">
                    <radial-progress-bar :diameter="300"
                                         :stroke-width="20"
                                         :start-color="startColor"
                                         :animate-speed="animateSpeed"
                                         :fps="60"
                                         :inner-stroke-color="innerStrokeColor"
                                         :completed-steps="completedSteps"
                                         :total-steps="2000">
                        <small>状态: {{ callbackMsg }} ......</small>
                        <small>进度: {{ completedSteps/2000 * 100 | filterFloor }}%</small>
                    </radial-progress-bar>
                    <button @click.once="buildSite()" class="createbtn">生成站点</button>
                </div>
                <div v-else>
                    <p>站点生成成功！！</p>
                    <input type="text" v-model="siteDomain" readonly>
                    <a @click="downLoad()">点击下载装企ERP</a>
                    <button @click="viewSite()" class="createbtn">访问站点</button>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import cookie from 'vue-cookie'
    import RadialProgressBar from 'vue-radial-progress'
    export default {
        name: "BuildSite",
        components: {RadialProgressBar},
        data() {
            return {
                innerStrokeColor: '#e2e2e2',
                startColor: '#bbff42',
                stopColor: '#429321',
                completedSteps: 0,
                animateSpeed: 1500,
                siteStatus: false,
                apiDomain: 'http://wechat.lixun365.com',
                cycleHandler: 0,
                callbackMsg: '初始化',
                siteDomain: ''
            }
        },
        beforeRouteEnter(to, from, next) {
            if(cookie.get('erp_tk') && cookie.get('erp_st')) {
                switch (cookie.get('erp_st')) {
                    case '1':
                        next({ path: '/client' })
                        break
                    case '2':
                        next({ path:'/site_config' })
                        break
                    case '3':
                        next({ path: '/pay_meal' })
                        break
                    default:
                        next(true)
                        break
                }
            } else {
                next({path: '/client', query: { redirect: to.fullPath }})
            }
        },
        created: function() {
            this.siteDomain = this.$cookie.get('s_domain') ? this.$cookie.get('s_domain') : ''
            this.siteStatus = this.siteDomain ? true : false
        },
        filters: {
            filterFloor: function(value) {
                return Math.floor(value)
            }
        },
        methods: {
            buildSite: function() {
                clearInterval(this.cycleHandler)
                this.createWebSite()
            },
            createWebSite: function() {
                this.$axios.get(this.apiDomain + '/api/site.site/createwebsite', {params: {ticket: this.$cookie.get('erp_tk')}})
                    .then(res => {
                        if(res.data.code === 1001) {
                            this.completedSteps += 50
                            this.cycleHandler = setInterval(this.cycleHandle, 1000)
                        } else {
                            layer.msg(res.data.msg)
                        }
                    }).catch(err => { console.error(err) })
            },
            cycleHandle: function() {
                this.completedSteps += 50
                this.$axios.post(this.apiDomain + '/api/site.site/createclientsite', {ticket: this.$cookie.get('erp_tk')})
                    .then(res => {
                        if(res.data.code === 1001) {
                            this.completedSteps = 2000
                            this.animateSpeed = 1500
                            this.siteDomain = res.data.data.domain
                            this.$cookie.set('s_domain', res.data.data.domain, {expires: '1d'})
                            this.siteStatus = !this.siteStatus
                            clearInterval(this.cycleHandler)
                            //操作成功
                        } else if(res.data.code === 1000) {
                            if(this.completedSteps >= 2000)
                            {
                                this.startColor = '#FF6242'
                                this.stopColor = '#FF6242'
                            }
                            //错误执行代码
                        } else {
                            clearInterval(this.cycleHandler)
                            //操作失败
                        }
                        this.callbackMsg = res.data.msg
                    }).catch(err => {console.log(err)})
            },
            downLoad: function() {
                window.open("http://wechat.lixun365.com/center/Client/DownLoad")
            },
            viewSite: function() {
                if(this.siteDomain.length > 0) window.open('http://' + this.siteDomain + "?ticket=" + this.$cookie.get('erp_tk'))
            }
        }
    }
</script>

<style scoped>
    .radial-progress-container {
        margin: auto;
        margin-top: 20px;
    }
</style>